"use client";

import { c as _c } from "react/compiler-runtime";
import { getERC20Balances } from "../../../shared/utils/thirdweb-insights.js";
import { useQuery } from "@tanstack/react-query";
import { viemToThirdwebChain } from "../../../shared/constants/chains/b3Chain.js";
import { getChainById } from "../../../shared/utils/chains.js";
import { client } from "../../../shared/utils/thirdweb.js";
import invariant from "invariant";
import { getWalletBalance } from "thirdweb/wallets";
export function useTokenBalancesByChain(t0) {
  const $ = _c(23);
  const {
    address,
    chainsIds,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== chainsIds) {
    t2 = Array.isArray(chainsIds) ? chainsIds : [chainsIds];
    $[0] = chainsIds;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const chainIds = t2;
  let t3;
  if ($[2] !== chainIds) {
    t3 = chainIds.join(",");
    $[2] = chainIds;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== address || $[5] !== t3) {
    t4 = ["tokenBalancesByChain", address, t3];
    $[4] = address;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== address || $[8] !== chainIds) {
    t5 = async () => {
      ;
      try {
        const [nativeTokens, fungibleResponse] = await Promise.all([Promise.all(chainIds.map(async chainId => {
          const chain = getChainById(chainId);
          invariant(chain, "Chain is required");
          const walletBalance = await getWalletBalance({
            address,
            client,
            chain: viemToThirdwebChain(chain)
          });
          return {
            ...walletBalance
          };
        })), getERC20Balances(address, {
          chainIds
        })]);
        return {
          nativeTokens,
          fungibleTokens: fungibleResponse.data
        };
      } catch (t6) {
        const err = t6;
        console.error("Error fetching token balances:", err);
        throw err;
      }
    };
    $[7] = address;
    $[8] = chainIds;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = enabled && !!address && chainIds.length > 0;
  let t7;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = {
      queryKey: t4,
      queryFn: t5,
      enabled: t6,
      staleTime: 30000,
      gcTime: 300000,
      retry: 2,
      structuralSharing: true
    };
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const {
    data: combinedData,
    isLoading,
    error
  } = useQuery(t7);
  let t8;
  if ($[14] !== combinedData?.nativeTokens) {
    t8 = combinedData?.nativeTokens ?? [];
    $[14] = combinedData?.nativeTokens;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== combinedData?.fungibleTokens) {
    t9 = combinedData?.fungibleTokens ?? [];
    $[16] = combinedData?.fungibleTokens;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== error || $[19] !== isLoading || $[20] !== t8 || $[21] !== t9) {
    t10 = {
      nativeTokens: t8,
      fungibleTokens: t9,
      isLoading,
      error
    };
    $[18] = error;
    $[19] = isLoading;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}